import { useState, useEffect } from 'react';

import PHONEFINDER_PATHS from 'pages/FindYourPhone/paths';
import ABOUTUS_PATHS from 'pages/AboutUs/paths';

function usePaths(){

    const [ paths, setPaths ] = useState(null);

    useEffect(()=>{

        let lastSlash = window.location.pathname.charAt(window.location.pathname.length - 1)
        let lastSlashIndex = lastSlash === "/" ? window.location.pathname.slice(0, -1).lastIndexOf("/") : window.location.pathname.lastIndexOf("/")
        let only_path_name = window.location.pathname.substring(lastSlashIndex + 1).replaceAll("/", "")

        if(PHONEFINDER_PATHS.hasOwnProperty(only_path_name)){
            setPaths(PHONEFINDER_PATHS[only_path_name]);
        }
        if(ABOUTUS_PATHS.hasOwnProperty(only_path_name)){
            setPaths(ABOUTUS_PATHS[only_path_name]);
        }


        /*eslint-disable-next-line react-hooks/exhaustive-deps */
    },[window.location.pathname])

    return paths;

}

export default usePaths;